import authDetermined from 'root/src/client/logic/app/actions/authDetermined'
import { LOGIN_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import { CHANGE_PASSWORD_SUCCESS_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { authApi } from 'root/src/shared/util/authApi'

export default ({ password, newPassword }) => async (dispatch) => {
	const { error } = await authApi.changePassword({
		password,
		newPassword,
	})

	if (error) {
		throw error
	}

	dispatch(authDetermined())
	localStorage.clear()

	return pushRouteClient({
		routeId: LOGIN_ROUTE_ID,
		query: { modal: CHANGE_PASSWORD_SUCCESS_MODULE_ID },
	})
}
